export default "__VITE_ASSET__241767a1__"